module.exports = __webpack_public_path__ + "7cdb7861db55097265bcfaa02dbadfe1.jpg";